import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import MenuIcon from '@/leftDrawer/MenuIcon';
import { cn } from '@/lib/utils';

function DrawerCollapseSubMenu({
  subMenuOption,
  collapseSubMenu,
  handleCollapseSubMenuChange,
  isOpenByDefault,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleCollapseToggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (isOpenByDefault) setIsOpen(true);
  }, [isOpenByDefault]);

  return (
    <div className="text-white font-medium text-[13px]">
      <div
        className={cn(
          "flex cursor-pointer select-none items-center h-[48px] pl-[18px] pr-4 transition-all duration-200 hover:bg-[#162A42] hover:text-white",
          subMenuOption.active && "bg-[#1E2941] text-white border-l-[3px] border-white",
          subMenuOption.disabled && "cursor-not-allowed opacity-40 pointer-events-none"
        )}
        onClick={() => !subMenuOption.disabled && handleCollapseToggle()}
        data-cy={`${subMenuOption.key}-left-menu-option`}
      >
        <div className="min-w-[48px] shrink-0 opacity-70">
          <MenuIcon menuKey={subMenuOption.key} />
        </div>
        <span className="tracking-wide text-[12px] font-normal">
          <FormattedMessage id={'LeftDrawer.' + subMenuOption.key} />
        </span>
        {/* chevron removed to match referencia visuals */}
      </div>

      <div
        className={cn(
          "overflow-hidden transition-all duration-300 ease-in-out",
          isOpen ? "max-h-[1000px] opacity-100 py-1" : "max-h-0 opacity-0 py-0"
        )}
      >
        <div className="flex flex-col">
          {collapseSubMenu.map((collapseOption, collapseOptionIndex) => (
            <div
              key={collapseOption.key}
              className={cn(
                "flex cursor-pointer select-none items-center h-[40px] pl-[68px] pr-4 transition-all duration-200 hover:text-white hover:bg-white/5",
                collapseOption.active ? "bg-[#1a3655] text-white font-semibold" : "bg-[#1f4065] text-white font-normal",
                collapseOption.disabled && "cursor-not-allowed opacity-40 pointer-events-none"
              )}
              onClick={() =>
                !collapseOption.disabled &&
                handleCollapseSubMenuChange(subMenuOption.index, collapseOptionIndex, collapseOption.routeLink)
              }
              data-cy={`${collapseOption.key}-left-sub-menu-option`}
            >
              <span className="text-[12px]">
                <FormattedMessage id={'LeftDrawer.' + collapseOption.key} />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

DrawerCollapseSubMenu.propTypes = {
  /**
   * Submenu options props
   */
  subMenuOption: PropTypes.object.isRequired,
  /**
   * Array with the sub-menu options
   */
  collapseSubMenu: PropTypes.array.isRequired,
  /**
   * Function to handle the url change of the collapse-menu (submenu inside submenu)
   */
  handleCollapseSubMenuChange: PropTypes.func.isRequired,
  /**
   * Is open by default (when parent component is created)
   */
  isOpenByDefault: PropTypes.bool,
  /**
   * Default submenu index to open (if it is provided)
   */
  subMenuToOpenByIndex: PropTypes.number,
};

DrawerCollapseSubMenu.defaultProps = {
  isOpenByDefault: false,
  subMenuToOpenByIndex: null,
};

export default DrawerCollapseSubMenu;
